import { render, staticRenderFns } from "./compareDuplicates.vue?vue&type=template&id=36c78d85&"
import script from "./compareDuplicates.vue?vue&type=script&lang=js&"
export * from "./compareDuplicates.vue?vue&type=script&lang=js&"
import style0 from "./compareDuplicates.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports